<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask id="path-2-inside-1_1555_26764">
      <path
        d="M13 8H19C20.1046 8 21 8.89543 21 10V21C21 22.1046 20.1046 23 19 23H13V8Z"
      />
    </mask>
    <path
      d="M13.056207,8.224825V6.224825H11.056207V8.224825H13.056207ZM13.056207,23.224825H11.056207V25.224825H13.056207V23.224825ZM13.056207,10.224825H19.056207V6.224825H13.056207V10.224825ZM19.056207,10.224825V21.224825H23.056207V10.224825H19.056207ZM19.056207,21.224825H13.056207V25.224825H19.056207V21.224825ZM15.056207,23.224825V8.224825H11.056207V23.224825H15.056207ZM19.056207,21.224825V25.224825C21.265307,25.224825,23.056207,23.433925,23.056207,21.224825H19.056207ZM19.056207,10.224825H23.056207C23.056207,8.015685,21.265307,6.224825,19.056207,6.224825V10.224825Z"
      mask="url(#path-2-inside-1_1555_26764)"
    />
    <rect x="5" y="9" width="6" height="2" rx="0.5" />
    <rect x="5" y="13" width="6" height="2" rx="0.5" />
    <rect x="5" y="17" width="6" height="2" rx="0.5" />
    <rect
      x="9.033020"
      y="20.852400"
      width="6.000000"
      height="2.000000"
      rx="0.5"
      id="e2_rect"
      transform="matrix(2.15497 -0.0107959 0.00575936 0.999986 -17.8145 0.338258)"
    />
    <rect
      x="8.422390"
      y="18.568800"
      width="6.000000"
      height="2.000000"
      rx="0.5"
      id="e16_rect"
      transform="matrix(-0.0107959 -2.92409 0.999986 -0.00781491 -17.3222 47.8683)"
    />
    <rect
      x="9.927330"
      y="22.918700"
      width="6.000000"
      height="2.000000"
      rx="0.5"
      id="e17_rect"
      transform="matrix(2.0191 -0.788076 0.304236 0.772994 -25.9326 -4.25468)"
    />
    <rect
      x="13.005800"
      y="26.305600"
      width="6.000000"
      height="2.000000"
      rx="0.5"
      id="e18_rect"
      transform="matrix(0.0288028 -3.4767 1.10292 0.00955932 -16.5623 67.4737)"
    />
    <rect
      x="5.960440"
      y="6.119020"
      width="6.000000"
      height="2.000000"
      rx="0.5"
      id="e1_rect"
      transform="matrix(-0.34434 -0.104028 0.212532 -0.703494 15.2701 8.06352)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
  },
}
</script>
